module.exports = __webpack_public_path__ + "img/Work_6.aeae3a52.jpg";